import React, { useEffect, useState } from "react";
import axios from "axios";
import { Formik, Form } from "formik";
import { FieldGroup } from "../../../components";
import { CreateEventModal } from "../../../components/modals";
import UserEventList from "./UserEventList";

const EventsForm = ({ user }) => {
  const [openModal, setOpenModal] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [userEventList, setUserEventList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const onCreateNewEvent = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
  };

  const fetchEventList = async () => {
    const userEvents = await axios.get(`/api/users/${user.id}/events`);
    const { data } = await axios.get("/api/events");

    setEventList(data);
    setUserEventList(userEvents.data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchEventList();
  }, [user]);

  return (
    <div>
      {/* {isLoading && <Loading />} */}
      {!isLoading && (
        <UserEventList
          eventList={eventList}
          onCreateNewEvent={onCreateNewEvent}
          user={user}
          userEventList={userEventList}
        />
      )}

      <CreateEventModal
        open={openModal}
        closeModal={closeModal}
        afterSubmit={fetchEventList}
      />
    </div>
  );
};

export default EventsForm;
